import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import Home from "./pages/Home";
import Bespoke from "./pages/Bespoke";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div style={{ minHeight: "70vh" }} className="flex items-center justify-center bg-cream">
                    <p className="font-serif text-2xl text-navy">Something went adrift. Please refresh the page.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

function SmoothScroll() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);
    return null;
}

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <SmoothScroll />
                <ScrollToTop />
                <div className="grain-overlay" aria-hidden="true" />
                <Nav />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/bespoke" element={<Bespoke />} />
                </Routes>
                <Footer />
                <FloatingWhatsApp />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
